module.exports = __webpack_public_path__ + "static/media/confetti-alt.f754bedb.svg";